module.exports = __webpack_public_path__ + "static/bydesignconf-79f74673ffe5ea7a055f8a2e6c111482.png";